var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEllipse74 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 233,
  height: 222,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#B7D523",
  d: "M349.902 145.224A194.31 194.31 0 0 1 3.886 51.615 194.3 194.3 0 0 1 41.26-90.894l94.836 72.552a74.907 74.907 0 0 0 14.88 103.812 74.913 74.913 0 0 0 104.089-12.798z"
})));
export { SvgEllipse74 as ReactComponent };
export default __webpack_public_path__ + "8a73a484a1623c3e59f127dd8c9e6b20.svg";